import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollToTop from "react-scroll-to-top";

import HomeOne from "./pages/HomeOne";
import Product from "./components/Shop/Product";
// import HomeTwo from "./pages/HomeTwo";
import About from "./pages/About";
import Service from "./pages/Service";
import ServiceDetails from "./pages/ServiceDetails";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import Pricing from "./pages/Pricing";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import RouteScrollToTop from "./elements/RouteScrollToTop";
import Katalog from "./pages/Katalog";
import FormulirSd from "./pages/formulir";
import Quiz from "./quizz/Quiz";

// import HomeThree from "./pages/HomeThree";
// import HomeFour from "./pages/HomeFour";
// import HomeFive from "./pages/HomeFive";

function ExternalRedirect() {
  useEffect(() => {
    window.location.replace("https://ebook.gubukpustakaharmoni.web.id/");
  }, []);

  return <div>Mengalihkan...</div>;
}

function App() {
  // State untuk mengontrol tampilan banner
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    AOS.init({
      offset: 0,
      easing: "ease",
      once: true,
    });
    AOS.refresh();
  }, []);

  return (
    <HelmetProvider>
      {/* BANNER OVERLAY SECTION */}
      {showBanner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)", // Overlay hitam dengan opacity
            zIndex: 9999, // Memastikan banner berada paling depan
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ position: "relative", maxWidth: "90%", width: "500px" }}>
            {/* TOMBOL CLOSE (X) */}
            <button
              onClick={() => setShowBanner(false)}
              style={{
                position: "absolute",
                top: "-15px",
                right: "-15px",
                backgroundColor: "#e74c3c",
                color: "#ffffff",
                border: "none",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                fontSize: "20px",
                fontWeight: "bold",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.3)",
                zIndex: 10000,
              }}
              title="Tutup Banner"
            >
              &times;
            </button>

            {/* GAMBAR BANNER (Bisa diklik menuju link) */}
            <a
              href="https://ebook.gubukpustakaharmoni.web.id/#/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setShowBanner(false)} // Opsional: tutup banner saat di-klik
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/banner.jpeg"}
                alt="Promo Banner"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "10px",
                  boxShadow: "0px 10px 30px rgba(0,0,0,0.5)",
                  cursor: "pointer",
                }}
              />
            </a>
          </div>
        </div>
      )}

      <BrowserRouter>
        <RouteScrollToTop />
        <Routes>
          <Route
            path={process.env.PUBLIC_URL + "/katalog/:id"}
            element={<Product />}
          />
          <Route
            path={process.env.PUBLIC_URL + "/katalog"}
            element={<Katalog />}
          />

          <Route exact path="/" element={<HomeOne />} />

          <Route exact path="/contact" element={<Contact />} />
          <Route path="/E-Learning" element={<ExternalRedirect />} />
        </Routes>
        <ScrollToTop smooth color="#52920a" />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;